<template>
  <dialog-edit2 :value="isShow" @input="clickClose" :makeFocus="false" :maxWidth="dialogWidth">
    <template v-slot:title> {{ source.title || title }} </template>
    <v-card-text style="height: 70vh; overflow: auto" class="pa-0">
      <a-table-f-api
        v-if="type == 'api'"
        ref="table"
        :api="url"
        :model="model"
        :useQuery="false"
        :defaults="{
          sort: { key: 'id', order: 'DESC' },
          filters: filter,
          paramName: tableParamName,
        }"
        @click="clickRow"
      /> 
      <a-table-f-api-post
        v-if="type == 'apiPost'"
        ref="table"
        :apiPost="{ api: '/report_sql/filters', params: paramsApi }"
        :limit="50"
        :model="model"
        :useQuery="false"
        :defaults="{
          sort: { key: 'id', order: 'DESC' },
          filters: filter,
          paramName: tableParamName,
        }"
        @click="clickRow"
      >
        <template v-slot:footerText>
          <span v-if="$refs.table">Показано: {{ $refs.table.pager.count }}</span>
        </template>
      </a-table-f-api-post>
      <a-table-f-data2
        v-if="type == 'data'"
        ref="table"
        :dataTable="data"
        :model="model"
        :searchable="false"
        :useQuery="false"
        :defaults="{
          sort: { key: 'id', order: 'DESC' },
          filters: filter,
          paramName: tableParamName,
        }"
        @click="clickRow"
      />
    </v-card-text>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn @click="clickClose()">Закрыть</v-btn>
    </template>
  </dialog-edit2>
</template>

<script>
import { getAccess, genModel } from "@/components/mixings";

export default {
  components: {},
  mixins: [getAccess, genModel],
  props: {
    opts: { type: Object, default: () => {} },
    title_: String,
    value: Boolean,
    source_: { type: Object, default: () => {} },
    mode: { type: String, default: "sync" },
  },
  data() {
    return {
      data: [],
      title: null,
      isShow: false,
      source: {},
      type: null,
      paramsApi: null,
      dialogWidth: "800px",
    };
  },
  computed: {
    m() {
      if (!this.source.model) return {};
      let model = this.source.model;
      if (typeof model == "string") return JSON.parse(JSON.stringify(this.$store.getters["config/get"].models[model]));
      if (typeof model == "object") return model;

      return {};
    },
    model() {
      //console.log("get model doc", this.source);
      const f = this.source?.fields || this.source?.docFields || "";
      let fields = f.split(",") || [];
      let model = this.getModelList(this.m);
      model = model.filter((el) => {
        return fields.includes(el.name);
      });
      model.forEach((m) => {
        m.hidden = false;
      });
      return model;
    },
    url() {
      return this.source.api;
    },

    filter() {
      return this.source?.filter || {};
    },
    tableParamName() {
      return this.source?.tableParamName || this.m?.tableParamName || "";
    },
  },
  created() {
    if (this.mode == "sync") this.init(this.opts);
  },
  watch: {
    isShow(v) {
      if (!v) {
        this.type = null;
      }
    },
    value(v) {
      if (this.mode == "sync") {
        this.isShow = v;
      }
    },
  },
  methods: {
    init(opts) {
      this.title = opts?.title;
      this.source = opts?.source || {};
      this.type = this.getType();
      console.log(this.source);
      if (this.source?.width) this.dialogWidth = `${this.source?.width}px`;
      if (this.type == "apiPost") this.paramsApi = this.source.paramsApi;
    },
    show(opts = {}) {
      console.log("show", opts);
      this.resetForm();
      this.init(opts);
      this.isShow = true;
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    getType() {
      if (typeof this.source.api === "string" && this.source.api.includes("/report_sql")) return "apiPost";
      if (typeof this.source.api === "string") return "api";

      if (typeof this.source.api === "object" && this.source.api.type == "post") {
        this.getListData();
        return "data";
      }
      return "";
    },
    resetForm() {
      this.source = {};
      this.isShow = false;
      this.title = null;
      this.paramsApi = null;
      this.dialogWidth = "800px";
      this.loaded = false;
    },
    async getListData() {
      this.data = [];
      let api = this.source.api;
      if (!api) return;
      let type = "get";
      let data = {};
      if (typeof api === "object") {
        type = api.type || type;
        if (api.data) {
          data.name = api.data?.name;
          data.params = {};
          for (const key in api.data.params) {
            console.log("key is func", key, typeof api.data.params[key]);

            // if (typeof api.data.params[key] === "function") {
            if (typeof api.data.params[key] === "string" && api.data.params[key].includes("function(d)")) {
              let func = eval(api.data.params[key]);
              console.log("key is func", key);
              data.params[key] = func(this.values) || 0;
            } else data.params[key] = api.data.params[key];
          }
        }

        //data = api.data || null;
        api = api.api;
      }
      let response = type == "get" ? await this.$axios.get(api, { params }) : await this.$axios.post(api, data);
      let listData = response.data.data;
      console.log("listData", listData);
      this.data = [...listData];
    },
    clickRow(d) {
      if (this.mode == "sync") {
        this.$emit("select", d.row);
        this.$emit("input");
      } else {
        this.isShow = false;
        this.resolvePromise(d.row);
      }
    },
    clickClose() {
      if (this.mode == "sync") {
        this.$emit("input");
      } else {
        this.isShow = false;
        this.resolvePromise(false);
      }
    },
  },
};
</script>
